import { navigatorActualBsRes } from './../store/navigator/navigator.selectors';
import { environment } from 'src/environments/environment';
import { sessionIsUsuarioExterno, sessionUsuario } from './../session/store/session.selectors';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription, Observable, of, combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { sessionOpen } from '../session/store/session.selectors';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { EncuestaSatisfaccionComponent } from '../encuesta-statisfaccion/encuesta-satisfaccion.component';
import { Router } from '@angular/router';
import { SidebarCollapseRequested, SidebarToggleRequested } from '../base/home/store/acceso/acceso.actions';
import { accesoSidebarCollapsed } from '../base/home/store/acceso/acceso.selectors';

@Component({
	selector: 'main-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

	private userName$: Observable<string>;
	private userPhoto$: Observable<Object>;
	private isUsuarioExterno$: Observable<boolean>;

	public isSessionOpen$: Observable<boolean>;
	private sessionUserPhoto$: Observable<string | null>;
	private navigatorSubscription: Subscription;
	private miniMenuActivated: boolean = false;
	private collapsedSearchActivated: boolean = false;
	private resolution: string;

	private miniMenuVisibleResolutions: Array<string> = [ 'xs', 'sm', 'md' ];
	private collapsedIconVisibleResolutions: Array<string> = [ 'xs', 'sm' ];

	@ViewChild( "encuesta", { static: true } )
	private encuesta: EncuestaSatisfaccionComponent;
	private encuestaCompletedSubscription: Subscription;


	constructor( private store: Store<AppState>, private router: Router ) {
	}

	ngOnInit() {
		this.isSessionOpen$ = this.store.select( sessionOpen );
		this.userName$ = this.store.select( sessionUsuario ).pipe(
			map( usuario => usuario? `${usuario.nombre} ${usuario.apellido}`: null )
		);
		this.userPhoto$ = this.store.select( sessionUsuario ).pipe(
			map( usuario => usuario && usuario.foto? { 'background-image': `url( ${usuario.foto} )` }: null )
		);

		this.sessionUserPhoto$ = this.store.select( sessionUsuario ).pipe(
			map( usuario => usuario?.foto || null )
		);

		this.navigatorSubscription = combineLatest( [ this.store.select( navigatorActualBsRes ), this.store.select( accesoSidebarCollapsed ) ] ).pipe(
			tap( ([ actualBsRes, sidebarCollapsed ]) => {
				this.resolution = actualBsRes;
				if( !sidebarCollapsed && !this.isSidebarAvailable() )
					this.onSidebarSelected();
			})
		).subscribe();

		this.isUsuarioExterno$ = this.store.select( sessionIsUsuarioExterno );
	}

	ngOnDestroy(): void {
		this.navigatorSubscription.unsubscribe();
		if( this.encuestaCompletedSubscription )
			this.encuestaCompletedSubscription.unsubscribe();
	}

	onSidebarSelected() {
		this.store.dispatch( new SidebarToggleRequested() );
	}

	onCollapsedSearchOpen() {
		this.toggleCollapsedSearch();
	}

	onCollapsedSearchClose() {
		this.toggleCollapsedSearch();
	}

	onMenuUsuarioChange( open: boolean ) {
		if( open )
			this.store.dispatch( new SidebarCollapseRequested() );
	}

	isCollapsedSearchVisible() {
		return this.resolution == 'md' || this.collapsedSearchActivated;
	}

	isCollapsedSearchIconVisible() {
		return this.collapsedIconVisibleResolutions.indexOf( this.resolution ) > -1 && !this.collapsedSearchActivated;
	}

	isUserContainerSmallVisible() {
		return ( this.collapsedIconVisibleResolutions.indexOf( this.resolution ) > -1 && !this.isCollapsedSearchVisible() ) ||
			this.collapsedIconVisibleResolutions.indexOf( this.resolution ) == -1;
	}

	miniMenuClosed() {
		this.miniMenuIconToggle();
	}

	miniMenuIconToggle() {
		this.miniMenuActivated = !this.miniMenuActivated;
	}

	onRestaurarVersionAnterior() {
		this.encuestaCompletedSubscription = this.encuesta.onEncuestaProps().pipe(
			switchMap( props => {
				let observable: Observable<Boolean> = null;
				// Si corresponde mostrar => abro la encuesta
				// sino => restauro directamente a la versión anterior
				if( props.mostrar ) {
					this.encuesta.open();
					observable = this.encuesta.onCompleted()
						.pipe(
							tap( completed => {
								// Una vez que llenó exitosamente el formulario => se vuelve a la Intranet Legacy
								if( completed )
									this.restaurarVersionAnterior();
							})
						);
				} else {
					this.restaurarVersionAnterior();
					observable = of( true );
				}
				return observable;
			}),
			first()
		).subscribe();
	}

	onOpenSugerencias() {
		// Es importante realizar una desubscripción de encuestaCompletedSubscription dado que si se abre el formulario
		// de sugerencias desde el desplegable de la derecha, y el usuario cierra el modal cliqueando afuera del modal,
		// no se está generando un objeto en el onCompleted porque no hay control sobre ese click. Entonces es
		// bueno hacer la desubscripción dado el onOpenSugerencias() anula la opción onRestaurarVersionAnterior().
		if( this.encuestaCompletedSubscription )
			this.encuestaCompletedSubscription.unsubscribe();
		this.encuesta.open();
	}

	private toggleCollapsedSearch() {
		this.collapsedSearchActivated = !this.collapsedSearchActivated;
	}

	private isSidebarAvailable(): boolean {
		return this.miniMenuVisibleResolutions.indexOf( this.resolution ) > -1;
	}

	private restaurarVersionAnterior() {
		window.location.href = environment.legacyIndexUrl;
	}

}
